<template>
    <div class="dialog-body d-flex flex-column h-100">
        <div class="flex flex-grow-1 d-flex flex-column dialog-content overflow-auto">
            <div>
                <div id="dgs-template"  class="d-flex flex-wrap template_filter_container">
                    <div class="search-bar-gray d-flex" style=" min-width: 26.25rem;">
                        <v-btn class="p-0" @click="searchTemplates()"><v-icon>mdi-magnify</v-icon></v-btn>
                        <v-text-field id="search" v-model="search" solo :label="SearchLabel" @keydown.enter="searchTemplates()"></v-text-field>
                        <v-btn class="p-0" v-if="search.length" @click="clear()"><v-icon>mdi-close</v-icon></v-btn>
                    </div>
                    <div class="template_filter">
                        <label>{{ $t("res_Label_TemplateType") }}</label>
                        <v-menu bottom offset-y :close-on-content-click="false" v-model="filter_menu1">
                            <template v-slot:activator="{ on, attrs }">
                                <button class="radio-dropdown" v-bind="attrs" v-on="on">
                                    <span>{{ (templateType == -1 ? $t("res_Label_Select") : templateTypes.find(x => x.id ==
                                        templateType).name) }}</span><v-icon>mdi-menu-down</v-icon>
                                </button>
                            </template>
                            <v-list class="py-3 px-3 filterPopup">
                                <v-radio-group class="m-0" v-for="(item, index) in templateTypes" :key="index" v-model="templateType" v-show="item.count > 0" >
                                    <v-radio  :label="item.name + ' (' + item.count + ')'" :value="item.id"></v-radio>
                                </v-radio-group>
                                <v-divider></v-divider>
                                <div class="d-flex justify-content-between">
                                    <a class="clear-btn" @click="clearByTemplateType">{{ $t("res_ButtonText_Clear") }}</a>
                                    <a class="btn-text primary-text weight-500 text-underline" @click="searchByTemplateType">{{ $t("res_ButtonText_Apply") }}</a>
                                </div>
                            </v-list>
                        </v-menu>
                    </div>
                    <div class="template_filter">
                        <label>{{ $t("res_Label_Language") }}</label>
                        <v-menu bottom offset-y :close-on-content-click="false" v-model="filter_menu2" offset>
                            <template v-slot:activator="{ on, attrs }">
                                <button class="radio-dropdown" v-bind="attrs" v-on="on">
                                    <span>{{ (language == -1 ? $t("res_Label_Select") : language) }}</span><v-icon>mdi-menu-down</v-icon>
                                </button>
                            </template>
                            <v-list class="py-3 px-3 filterPopup">
                                <v-radio-group class="m-0" v-for="(item, index) in languages" :key="index" v-model="language" v-show="item.count > 0" >
                                    <v-radio 
                                        :label="chooseLanguageLabel(item.name)"
                                        :value="item.name == 'EN' ? 'EN' : (item.name == 'AR' ? 'AR' : item.name)"></v-radio>
                                </v-radio-group>
                                <v-divider></v-divider>
                                <div class="d-flex justify-content-between">
                                    <a class="clear-btn" @click="clearTemplatesByLanguage">{{ $t("res_ButtonText_Clear") }}</a>
                                    <a class="btn-text primary-text weight-500 text-underline" @click="searchTemplatesByLanguage">{{ $t("res_ButtonText_Apply") }}</a>
                                </div>
                            </v-list>
                        </v-menu>
                    </div>
                    <div class="template_filter">
                        <label>{{ $t("res_Label_SignatureRequired") }}</label>
                        <v-menu bottom offset-y :close-on-content-click="false" v-model="filter_menu3">
                            <template v-slot:activator="{ on, attrs }">
                                <button class="radio-dropdown" v-bind="attrs" v-on="on">
                                    <span>{{ (signatureCount == -1 ? $t("res_Label_Select") : signatureCount) }}</span><v-icon>mdi-menu-down</v-icon>
                                </button>
                            </template>
                            <v-list class="py-3 px-3 filterPopup">
                                <v-radio-group class="m-0" v-for="(item, index) in singatureCounts" :key="index" v-model="signatureCount" v-show="item.count > 0" >
                                    <v-radio :label="item.name" :value="item.name"></v-radio>
                                </v-radio-group>
                                <v-divider></v-divider>
                                <div class="d-flex justify-content-between">
                                    <a class="clear-btn" @click="clearTemplatesBySignatruesCount">{{ $t("res_ButtonText_Clear") }}</a>
                                    <a class="btn-text primary-text weight-500 text-underline" @click="searchTemplatesBySignatruesCount">{{ $t("res_ButtonText_Apply") }}</a>
                                </div>
                            </v-list>
                        </v-menu>
                    </div>
                    <div class="template_filter">
                        <label>{{ $t("res_Label_Tags") }}</label>
                        <v-menu bottom offset-y :close-on-content-click="false" v-model="filter_menu4">
                            <template v-slot:activator="{ on, attrs }">
                                <button class="radio-dropdown" v-bind="attrs" v-on="on">
                                    <span>{{ (tag == -1 ? $t("res_Label_Select") : tag) }}</span><v-icon>mdi-menu-down</v-icon>
                                </button>
                            </template>
                            <v-list class="py-3 px-3 filterPopup">
                                <v-radio-group class="m-0" v-for="(item, index) in tags" :key="index" v-model="tag" v-show="item.count > 0" >
                                    <v-radio :label="item.name + ' (' + item.count + ')'" :value="item.name"></v-radio>
                                </v-radio-group>
                                <v-divider></v-divider>
                                <div class="d-flex justify-content-between">
                                    <a class="clear-btn" @click="clearTemplatesByTags">{{ $t("res_ButtonText_Clear") }}</a>
                                    <a class="btn-text primary-text weight-500 text-underline" @click="searchTemplatesByTags">{{$t("res_ButtonText_Apply")}}</a>
                                </div>
                            </v-list>
                        </v-menu>
                    </div>
                    <!-- <div class="template_filter" v-if="constants.client_version_Id != 'DGS'">
                        <label>{{ $t("res_Label_Privacy") }}</label>
                        <v-menu bottom offset-y :close-on-content-click="false" v-model="filter_menu5">
                            <template v-slot:activator="{ on, attrs }">
                                <button class="radio-dropdown" v-bind="attrs" v-on="on">
                                    <span>{{ (privacy == -1 ? $t("res_Label_Select") : privacies.find(x => x.id == privacy).name) }}</span><v-icon>mdi-menu-down</v-icon>
                                </button>
                            </template>
                            <v-list class="py-3 px-3 filterPopup">
                                <v-radio-group class="m-0" v-for="(item, index) in privacies" :key="index" v-model="privacy">
                                    <v-radio :label="item.name + ' (' + item.count + ')'" :value="item.id"></v-radio>
                                </v-radio-group>
                                <v-divider></v-divider>
                                <div class="d-flex justify-content-between">
                                    <a class="clear-btn" @click="clearTemplatesByPrivacy">{{ $t("res_ButtonText_Clear") }}</a>
                                    <a class="btn-text primary-text weight-500 text-underline" @click="searchTemplatesByPrivacy">{{ $t("res_ButtonText_Apply") }}</a>
                                </div>
                            </v-list>
                        </v-menu>
                    </div> -->
                    <div >
                        <v-btn class="light-clear-btn" icon @click="clearAllFilters()"><v-icon>mdi-delete-empty-outline</v-icon></v-btn>
                    </div>
                </div>
            </div>
            <div class="d-flex flex-grow-1 overflow-auto m-0 divided_row">
				<div class="col-lg-6 p-0 left-side">
                    <div v-if="!showTreeView" id="dgs-template" class="h-100 overflow-auto">
                        <h2 class="main-text-large pl-6 pr-6 chose-template-fav" style="color: #667593!important;">{{ $t("res_CardHeaders_FavoriteCorrespondences")}} ({{ favoriteCorrespondences.length }})</h2>
                        <div class="grid-2-items">
                            <div v-for="(item, i) in favoriteCorrespondences" :key="i">
                                <v-card  id="dgs-card" class="bg-white template_card pb-0 dgs-min-height-120px" @dblclick="createSelected()"  @click="handleTemplateClicked(item, true)"
                                    :class="{ 'template_selected': item.id === selectedTemplateId }"
                                    style="min-height: 160px;">
                                    <div class="d-flex flex-row justify-content-between align-items-center" style=" margin-bottom:33px" >
                                        <div class="d-flex flex-column  p-0 ">
                                            <h3 class="mt-0 mb-0  p-0 main-text-large">{{ item.favoriteName }}</h3>
                                            <p class="action-label-new ">{{ item.name }}</p>
                                        </div>
                                        <div class="d-flex gap-2 align-self-start">
                                            <v-chip dark style="background:transparent; " class="float-right p-0"
                                                @click="openRemoveFavoriteDialog(item.documentId)">
                                                <v-icon style="color: goldenrod;">mdi-star-circle</v-icon>
                                            </v-chip>
                                        </div>
                                    </div>
                                    <div class="dgs-vchip-flex">
                                        <v-chip class="light-blue-dgs">{{ item.language }}</v-chip>
                                        <v-chip  class="blue-dgs">{{  item.signatureCount }} {{ $t("res_Label_Signature") }}</v-chip>
                                    </div>
                                </v-card>
                            </div>
                        </div>

                        <h2 class="main-text-large pl-6 pr-6 chose-template-fav" style="color: #667593!important;">{{ $t("res_CardHeaders_Favorites")}} ({{ favourite_templates.length }})</h2>
                        <div class="grid-2-items">
                            <div v-for="(item, i) in favourite_templates" :key="i">
                                <v-card  v-tooltip="item.categoryName" id="dgs-card" class="bg-white template_card pb-0 d-grid dgs-min-height-120px"  @dblclick="createSelected()" @click="handleTemplateClicked(item)"
                                    :class="{ 'template_selected': item.id === selectedTemplateId }"
                                    style="min-height: 160px;">
                                    <div class="d-flex flex-row justify-content-between align-items-center" style=" margin-bottom:10px" >
                                        <div class="d-flex flex-column  p-0 ">
                                            <h3 class="mt-0 mb-0  p-0 main-text-large">{{ item.name }}</h3>
                                            <p class="action-label-new ">{{ item.descriptionEn }}</p>
                                        </div>
                                        <div class="d-flex gap-2 align-self-start">
                                            <v-chip dark style="background:transparent" class="float-right p-0" @click="RemoveFromFavorites(item.id)">
                                                <v-icon style="color: goldenrod;">mdi-star-circle</v-icon>
                                            </v-chip>
                                            <v-chip dark style="background:transparent" class="float-right view-icon p-0" @click="scrollIntoViewer()">
                                                <v-icon small color="blue">mdi-eye</v-icon>
                                            </v-chip>
                                        </div>
                                    </div>
                                    <div class="dgs-vchip-flex">
                                        <v-chip class="light-blue-dgs">{{ item.language }}</v-chip>
                                        <v-chip dark class="light-blue-dgs" v-if="item.tags.length > 0">{{  item.tags }}</v-chip> 
                                        <v-chip class="blue-dgs">{{  item.signatureCount }} {{ $t("res_Label_Signature") }}</v-chip>
                                    </div>
                                </v-card>
                            </div>
                        </div>


                        <h2 class="main-text-large pl-6 pr-6 chose-template-fav" style="color: #667593!important;">{{ $t("res_CardHeaders_StructureTemplates")}} ({{ my_templates.length }})</h2>
                        <div class="grid-2-items">
                            <div v-for="(item, i) in my_templates" :key="i">
                                <v-card  v-tooltip="item.categoryName" id="dgs-card" class="bg-white template_card pb-0 d-grid dgs-min-height-120px" @dblclick="createSelected()"  @click="handleTemplateClicked(item)"
                                    :class="{ 'template_selected': item.id === selectedTemplateId }"
                                    style="min-height: 160px;">
                                    <div class="d-flex flex-row justify-content-between align-items-center" style=" margin-bottom:10px" >
                                        <div class="d-flex flex-column  p-0 ">
                                            <h3 class="mt-0 mb-0  p-0 main-text-large">{{ item.name }}</h3>
                                            <p class="action-label-new ">{{ item.descriptionEn }}</p>
                                        </div>
                                        <div class="d-flex gap-2 align-self-start">
                                            <v-chip v-if="!item.isDocument" style="cursor: pointer !important;" class="p-1">
                                                <v-icon style="cursor: pointer !important; color: goldenrod;" @click="RemoveFromFavorites(item.id)" v-if="item.favoriteTemplate > 0">mdi mdi-star-circle</v-icon>
                                                <v-icon style="cursor: pointer !important;" @click="addToFavorites(item.id)" v-if="item.favoriteTemplate == 0">mdi mdi-star-outline</v-icon>
                                            </v-chip>
                                            <v-chip dark style="background:transparent" class="float-right view-icon p-0" @click="scrollIntoViewer()">
                                                <v-icon small color="blue">mdi-eye</v-icon>
                                            </v-chip>
                                        </div>
                                    </div>
                                    <div class="dgs-vchip-flex">
                                        <v-chip class="light-blue-dgs">{{ item.language }}</v-chip>
                                        <v-chip dark class="light-blue-dgs" v-if="item.tags.length > 0">{{  item.tags }}</v-chip> 
                                        <v-chip class="blue-dgs">{{  item.signatureCount }} {{ $t("res_Label_Signature") }}</v-chip>
                                    </div>
                                </v-card>
                            </div>
                        </div>

                        <h2 class="main-text-large pl-6 pr-6" style="color: #667593!important;">{{ $t("res_CardHeaders_All")}} ({{ templates.length }})</h2>
                        <div class="grid-2-items">  
                            <div v-for="(item, i) in templates" :key="i"> 
                                <v-card  v-tooltip="item.categoryName" id="dgs-card" class="on-hover-display bg-white template_card dgs-card-selected d-grid dgs-min-height-120px" @click="handleTemplateClicked(item)" @dblclick="createSelected()"
                                    :class="{ 'template_selected': item.id === selectedTemplateId }"
                                    style="min-height: 160px">
                                    <div class="d-flex flex-row justify-content-between align-items-center" style="gap:10px; margin-bottom: 33px">
                                        <div class="d-flex flex-column  p-0 ">
                                            <h3 class="mt-0 mb-0  p-0 main-text-large">{{ item.name }} </h3>
                                            <p class="action-label-new ">{{ item.descriptionEn }}</p>
                                        </div>
                                        <div class="d-flex gap-2 align-self-start">
                                            <v-chip v-if="!item.isDocument" style="cursor: pointer !important;" class="p-1">
                                                <v-icon style="cursor: pointer !important; color: goldenrod;" @click="RemoveFromFavorites(item.id)" v-if="item.favoriteTemplate > 0">mdi mdi-star-circle</v-icon>
                                                <v-icon style="cursor: pointer !important;" @click="addToFavorites(item.id)" v-if="item.favoriteTemplate == 0">mdi mdi-star-outline</v-icon>
                                            </v-chip>
                                            <v-chip dark style="background:transparent" class="float-right view-icon p-0"
                                                @click="scrollIntoViewer()">
                                                <v-icon small color="blue">mdi-eye</v-icon>
                                            </v-chip>
                                        </div>
                                    </div>
                                    <div class="dgs-vchip-flex m-0 p-0" >
                                        <v-chip dark class="light-blue-dgs" >{{ item.language }}</v-chip>
                                        <v-chip dark class="light-blue-dgs" v-if="item.tags.length > 0">{{  item.tags }}</v-chip> 
                                        <v-chip dark class="blue-dgs">{{ item.signatureCount }} {{ $t("res_Label_Signature") }}</v-chip>
                                    </div>
                                </v-card>
                            </div>
                        </div>
                    </div>
                    <div v-if="showTreeView" id="dgs-template"  class="h-100 overflow-auto">
                        <v-treeview style="margin:0 2% 0 2%;overflow-x: hidden;" class="flex-1 "  dense :items="templateTags" ref="tree"
                            activatable item-key="id" color="success" open-on-click
                            open-all="true"
                            transition>  
                            
                               <template v-slot:label="{ item }">
                                    <div v-if="item.children" @contextmenu="show($event, item)" :style="{ color: item.active ? 'red' : 'black' }">
                                        {{ (lang == 'ar' && item.nameAr != '') ? item.nameAr : item.name  + (item.children?  " ( " +item.children.length+" )":'')  }}
                                    </div>
                                    <div v-if="!item.children" @click="handleTemplateClicked(item , item.isDocument == true)" @dblclick="createSelected()" @contextmenu="show($event, item)" :style="{ color: item.active ? 'red' : 'black' }">
                                        {{ item.name }}
                                    </div>
                                </template> 

                                <template v-slot:prepend="{ item, open }">
                                    <div @contextmenu="show($event, item)" >
                                        <v-icon >
                                            {{ 
                                              !item.children ? 'mdi-file-document' 
                                             : item.id > -1 && !open ? 'mdi-text-box-plus-outline' :  item.id > -1 && open ? 'mdi-text-box-minus-outline'
                                             : item.id ==  templatesTreeIndexes.structureTemplates && !open ? 'mdi-account-group' :  item.id == templatesTreeIndexes.structureTemplates && open ? 'mdi-account-group-outline'  
                                             : item.id ==  templatesTreeIndexes.favoriteCorrespondances && !open ? 'mdi-file-star' :  item.id == templatesTreeIndexes.favoriteCorrespondances && open ? 'mdi-file-star-outline'  
                                             : item.id ==  templatesTreeIndexes.favorites && !open ? 'mdi-star-plus' :  item.id == templatesTreeIndexes.favorites && open ? 'mdi-star-minus' : ''
                                            }} 
                                        </v-icon> 
                                    </div> 
                                </template>

                                <template  v-slot:append="{ item, open }">
                                    <div style="padding-right:10px;border-top:0px !important" v-if="!item.children" class="dgs-vchip-flex">
                                            <v-chip v-if="!item.isDocument" style="cursor: pointer !important;" class="p-1">
                                                <v-icon style="cursor: pointer !important;" @click="RemoveFromFavorites(item.id)" v-if="item.favoriteTemplate > 0">mdi mdi-star-off-outline</v-icon>
                                                <v-icon style="cursor: pointer !important;" @click="addToFavorites(item.id)" v-if="item.favoriteTemplate == 0">mdi mdi-star-outline</v-icon>
                                            </v-chip>   
                                            <v-chip v-if="item.isDocument" style="cursor: pointer !important;" class="p-1">
                                                <v-icon style="cursor: pointer !important;" @click="openTreeRemoveFavoriteDialog(item.documentId)">mdi mdi-star-off-outline</v-icon>
                                             </v-chip>   
                                            <v-chip class="light-blue-dgs">{{ item.language }}</v-chip> 
                                            <v-chip class="blue-dgs">{{  item.signatureCount }}  {{ $t("res_Label_Signature") }}</v-chip>
                                    </div>
                                </template> 

                        </v-treeview>

                        <v-dialog v-model="removeFavoriteDialogFromTree" content-class="small-dialog" width="500" height="350">
                                        <v-card>
                                            <v-card-title>
                                                {{ $t("res_Label_Alert") }}
                                            </v-card-title>
                                            <div class="card-body">
                                                <h3>{{ $t("res_Msgs_EnsureRemoveFavorite") }}</h3> 
                                            </div>
                                            <v-card-actions class="gap-2 sticky-actions">
                                                <v-spacer></v-spacer>
                                                <v-btn color="light-blue" @click="removeFavoriteDialogFromTree = false">{{ $t("res_ButtonText_Cancel") }}</v-btn>
                                                <v-btn color="primary" @click="RemoveFromDocumentFavoritesFromTree()">{{ $t("res_ButtonText_Continue") }}</v-btn>
                                            </v-card-actions>
                                        </v-card>
                        </v-dialog>

                    </div>
                </div>
				<div class="col-lg-6 right-side pt-0 pb-0 bkg-grey rounded-3" >
					<div class="viewer-wrapper overflow-auto h-100 bkg-grey">
                        <div v-if="empty_viewer" class="empty-viewer bkg-grey ">
                            <img src="/assets/images/icons/template.svg" />
                            <h2>{{ $t("res_Msgs_NoTemplatesSelected") }}</h2>
                            <p>{{ $t("res_Msgs_SelectViewTemplate") }}</p>
                        </div>
                        <div id="choose_template_viewer_template "  style="height: calc(100vh - 280px) !important;">
                            <iframe :src="viewerFrameSrc" style="width: 100%; height: calc(100% )"></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="dialog-footer sticky-footer top-shadow d-flex align-items-center justify-content-end position-relative">
            <v-btn color="light-blue" @click="closeSelectTemplatePopup()">{{ $t("res_ButtonText_Cancel") }}</v-btn>
            <v-btn v-if="isDocument" class="primary" :disabled="selectedTemplateId === 0" @click="createByDocument()">{{
                $t("res_ButtonText_Continue") }}</v-btn>
            <v-btn v-else class="primary" :disabled="selectedTemplateId === 0" @click="createTemplate()">{{
                $t("res_ButtonText_Continue") }}</v-btn>
        </div>
    </div>
</template>

<script>
import { defaultGet, defaultPost } from '@/assets/js/common.js'
import constants from '@/assets/js/constants.js'
import axios from 'axios'
import MultiSelect from 'vue-multiselect'
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed.js'
import * as utils from '@/assets/js/common.js'

export default {
    name: 'ChooseTemplate',
    components: { MultiSelect, VuePdfEmbed },
    props: {
        refreshToken: { type: String, default: '' },
        categoryType: { type: String, default: '' },
        dialogModelShow: { type: Boolean, default: false },
        isTreeView: { type: Boolean, default: false },
        linkedDocumentId:{type : Number, default : 0} 
    },
    data() {
        return {
            removeFavoriteDialogFromTree: false,
            selectedFavoriteDocumentId: 0,
            templatesTreeIndexes: {
                favorites: -3,
                favoriteCorrespondances:-2, 
                structureTemplates: -1,
                all: 0 
            },
            templateTags: [],
            allTemplates: [],
            active:[],
            showTreeView:constants.templateMode=='card'?false:true,
            empty_viewer: true,
            loading: false,
            templateType: -1,
            templateTypes: [],
            signatureCount: -1,
            singatureCounts: [],
            language: -1,
            languages: [],
            privacy: -1,
            privacies: [],
            tag: -1,
            tags: [],

            search: '',
            templates: [],
            favourite_templates: [],
            my_templates:[],
            favoriteCorrespondences: [],

            selectedTemplateId: 0,
            selectedTemplate: {},

            viewerFrameSrc: '',
            SearchLabel: '',
            filter_menu1: false,
            filter_menu2: false,
            filter_menu3: false,
            filter_menu4: false,
            filter_menu5: false,
            utils: utils,
            isDocument: false,
            documentId: 0,
            removeFavoriteDialog: false,
            lang: '',
            constants: constants,
            showPlusOnTemplateCard: window.showPlusOnTemplateCard
        };
    },
    watch:
    {
        isTreeView(newValue,oldValue){
            this.showTreeView = newValue
        },
        refreshToken: function (newVal, oldVal) {
            if (newVal != '' && newVal != oldVal)
                this.clearAllFilters()
        },
        dialogModelShow(newVal, oldVal) {
            this.getFavoriteCorrespondences()
            this.clearAllFilters()
            if (newVal != oldVal) {
                if (newVal == true) { }
                else {
                    this.closeSelectTemplatePopup()
                }
            }
        },
    },
    mounted: function () {
        this.lang = localStorage.getItem('lang');
        this.getFavoriteCorrespondences();
        this.clearAllFilters()
        this.SearchLabel = window.translate("res_Label_SearchPlaceHolder")
        this.showTreeView = constants.templateMode == 'card' ? false : true;  

        setTimeout(() => { 
            let elements = document.querySelectorAll(".v-treeview-node");
            elements.forEach(function(element) { 
                element.click();
            }); 
        }, 3000);
    },
    methods:
    {
        getAllDistinctTemplateTags(){
            axios.get(constants.baseApiUrl + 'Template/GetAllDistinctTemplateTags', { headers: constants.headers })
                .then(res =>
                {
                    let lang = localStorage.getItem('lang') == null ? 'en' : localStorage.getItem('lang').toLocaleLowerCase();  
                    let id = 1;
                    this.templateTags = []
                   
                    this.templateTags.push({
                                            id: this.templatesTreeIndexes.favorites,
                                            name: 'Favorites' ,
                                            nameAr: 'المفضلة' ,
                                            children: this.allTemplates.filter(s=> s.favoriteTemplate > 0)
                                        });
  
                    this.templateTags.push({
                                            id: this.templatesTreeIndexes.favoriteCorrespondances,
                                            name: 'Favorite Correspondences' ,
                                            nameAr: 'المراسلات المفضلة' ,
                                            children: this.favoriteCorrespondences.map(item => {
                                                    return {
                                                        signatureCount: item.signatureCount,
                                                        language: item.language,
                                                        name: item.favoriteName,
                                                        nameAr: item.favoriteName,
                                                        myTemplate: false,
                                                        favoriteTemplate: 0,
                                                        extraInfoText: '',
                                                        id: item.id, 
                                                        isDocument: true,
                                                        documentId: item.documentId,
                                                        categoryId: item.categoryId
                                                    }})
                                            }); 

                    this.templateTags.push({
                                            id: this.templatesTreeIndexes.structureTemplates,
                                            name: 'Structure Template' ,
                                            nameAr: 'نماذج الإدارة' ,
                                            children: this.allTemplates.filter(s=> s.myTemplate == true)
                                        }); 

                    this.templateTags.push({
                                            id: this.templatesTreeIndexes.all,
                                            name: 'All' ,
                                            nameAr: 'الجميع' ,
                                            children: this.allTemplates
                                        }); 
 
                                        
                    this.$nextTick(function () { if (this.$refs.tree) this.$refs.tree.updateAll(true);});
                }
                )
                .catch(err => this.handleError(err))
        },
        chooseLanguageLabel(item) { 
            return item == 'EN' ? this.$t('res_label_English') : item == 'AR' ?  this.$t('res_label_Arabic') : this.$t('res_Label_Bilingual'); 
        },
        chooseLanguageValue(item) {
            if(this.lang == 'ar') {
                return item == 'EN' ? 'الانجليزية' : 'العربية';
            } else {
                return item == 'EN' ? 'English' : 'Arabic';
            }
        },
        openMultiSelectCtrl(id) {
            if (id === 1) this.$refs.multiselect1.activate()
            else if (id === 2) this.$refs.multiselect2.activate()
            else if (id === 3) this.$refs.multiselect3.activate()
            else if (id === 4) this.$refs.multiselect4.activate()
            else if (id === 5) this.$refs.multiselect5.activate()
        },
        scrollIntoViewer() {
            document.getElementById("choose_template_viewer_template").scrollIntoView()
        },
        getTemplateFiltersAndStatistics() 
        {
            let catType = this.categoryType
            if (catType == '') catType = '0'; 

            const selectedLanguage = this.language == null || this.language == undefined ||  this.language == '-1'? '' : this.language; 
            const selectedTag = this.tag == null || this.tag == undefined ||  this.tag == '-1'? '' : this.tag; 
            const selectedNumberOfSignees = this.signatureCount == null || this.signatureCount == undefined ||  this.signatureCount == '-1'? 0 : this.signatureCount; 
            const selectedType = this.templateType == null || this.templateType == undefined ||  this.templateType == '-1'? 0 : this.templateType; 
 
            defaultGet(`Template/GetTemplateFiltersAndStatistics?categoryId=${catType}&selectedLanguage=${selectedLanguage}&selectedTag=${selectedTag}&selectedNumberOfSignees=${selectedNumberOfSignees}&selectedType=${selectedType}`, (res) => {
                if (res.data != null && res.data != undefined && res.data.length > 0) {
                    this.templateTypes = JSON.parse(res.data[0].templateTypes)
                    this.singatureCounts = JSON.parse(res.data[0].signatureCounts)
                    this.languages = JSON.parse(res.data[0].languages)
                    this.tags = (JSON.parse(res.data[0].tags) || []).filter(item => item.name != null && item.name.toString().trim() != '')
                    this.privacies = JSON.parse(res.data[0].privacies)
                }
            },
                this.handleError, true);
        },
        searchTemplates() {
            this.getTemplates()
        },
        searchByTemplateType() {
            this.filter_menu1 = false
            this.getTemplates()
        },
        clearByTemplateType() {
            this.templateType = -1
            this.searchByTemplateType()
        },
        searchTemplatesBySignatruesCount() {
            this.filter_menu3 = false
            this.getTemplates();
        },
        clearTemplatesBySignatruesCount() {
            this.signatureCount = -1
            this.searchTemplatesBySignatruesCount()
        },
        searchTemplatesByLanguage() {
            this.filter_menu2 = false
            this.getTemplates()
        },
        clearTemplatesByLanguage() {
            this.language = -1
            this.searchTemplatesByLanguage()
        },
        searchTemplatesByTags() {
            this.filter_menu4 = false
            this.getTemplates();
        },
        clearTemplatesByTags() {
            this.tag = -1
            this.searchTemplatesByTags()
        },
        searchTemplatesByPrivacy() {
            this.filter_menu5 = false
            this.getTemplates()
        },
        clearTemplatesByPrivacy() {
            this.privacy = -1
            this.searchTemplatesByPrivacy()
        },
        prepareRequestObject() {
            var requestObj = {}

            requestObj.Search = this.search

            if (this.templateType == null || this.templateType == undefined || this.templateType == -1) {
                if (this.categoryType == '')
                    requestObj.CategoryId = 0
                else
                    requestObj.CategoryId = this.categoryType
            }
            else
                requestObj.CategoryId = this.templateType

            if (this.language == null || this.language == undefined)
                requestObj.Language = ''
            else
                requestObj.Language = this.language

            if (this.signatureCount == null || this.signatureCount == undefined)
                requestObj.SignatureCount = 0
            else
                requestObj.SignatureCount = this.signatureCount

            if (this.tag == null || this.tag == undefined || this.tag == -1)
                requestObj.Tags = ''
            else
                requestObj.Tags = this.tag

            if (this.privacy == null || this.privacy == undefined || this.privacy == -1)
                requestObj.Privacy = -1
            else
                requestObj.Privacy = this.privacy

            return requestObj
        },
        getTemplates() 
        {
            var requestObj = this.prepareRequestObject()
            window.showLoading();
            axios.post(constants.baseApiUrl + 'Template/SearchTemplates', requestObj, { headers: constants.headers })
                .then(res => 
                {
                    this.allTemplates = [];
                    this.favourite_templates = [];
                    this.my_templates = [];
                    this.templates = [];
                    if (res.data != null && res.data != undefined) 
                    { 
                        window.hideLoading()
                        res.data.forEach(element => 
                        {
                            element.extraInfoCount = 0;
                            element.extraInfoText = '';
                            if (element.privacy)
                            {
                                element.extraInfoCount++;
                                element.privacyName = utils.getPrivacyName(element.privacy);
                            }
                            if (element.tags)
                                element.extraInfoCount++;

                            element.extraInfoText = [element.tags, element.privacyName].filter(item => item ).join(', ');

                            if (element.favoriteTemplate > 0)
                                this.favourite_templates.push(element)
                            if (element.myTemplate > 0)
                                this.my_templates.push(element)
                            
                            this.allTemplates.push(element)
                            this.templates.push(element)
                        })
                        this.getAllDistinctTemplateTags()
                    }
                })
                .catch(err => this.handleError(err))
                .finally(() => window.hideLoading())
        },
        handleTemplateClicked(item, isDocument = false) 
        { 
            this.isDocument = isDocument;
            if(isDocument) { this.documentId = item.documentId; }
            this.selectedTemplateId = item.id;
            this.selectedTemplate = item;
            this.empty_viewer = false;
            window.setViewerData('','');
            this.viewerFrameSrc = '/resources/viewer/viewer.html?templateId=' + this.selectedTemplateId + '&lang=' + this.$i18n.locale + '&defaultScale=page-width&pageMode=view' + '&r=' + new Date().getTime();
        },
        closeSelectTemplatePopup() {
            this.selectedTemplateId = 0
            this.viewerFrameSrc = "" 
            this.empty_viewer = true
            this.favoriteCorrespondences = []
            this.templates = []
            this.$emit('closeSelectTemplatePopup', 0)
        },
        addToFavorites(templateId) 
        {  
            window.showLoading() 
            var user = JSON.parse(sessionStorage.getItem("user"));
            var body = { UserId: user.profile.Id, TemplateId: templateId, CreatedDate: new Date().toISOString()}

            axios.post(constants.baseApiUrl + 'Template/AddFavoriteTemplateFile', body, { headers: constants.headers })
                .then(res => this.searchTemplates())
                .catch(err => this.handleError(err))
        },
        RemoveFromFavorites(templateId) 
        { 
            window.showInformation(this.$t('res_Label_Alert'), this.$t('res_Msgs_EnsureRemoveFavorite'),
                () => {
                    window.showLoading() 
                    axios.get(constants.baseApiUrl + 'Template/DeleteFavoriteTemplateFile?templateId=' + templateId, { headers: constants.headers })
                    .then(res => this.searchTemplates())
                    .catch(err => this.handleError(err))
                },
                () => { });
        },
        RemoveFromDocumentFavoritesFromTree()
        {  
            axios.get(constants.baseApiUrl + 'Document/DeleteFavorite?documentId=' + this.selectedFavoriteDocumentId , { headers: constants.headers })
                .then((res) => {
                    this.removeFavoriteDialogFromTree = false;
                    this.getFavoriteCorrespondences()  
                    let _favoriteCorrespondance = this.templateTags.find(s=>s.id == this.templatesTreeIndexes.favoriteCorrespondances);
                        _favoriteCorrespondance.children = _favoriteCorrespondance.children.filter(s=>s.documentId != this.selectedFavoriteDocumentId); 
                    this.selectedFavoriteDocumentId = 0;
                })
                .catch(err => this.handleError(err))
        },
        RemoveFromDocumentFavorites(documentId) 
        {
            axios.get(constants.baseApiUrl + 'Document/DeleteFavorite?documentId=' + documentId, { headers: constants.headers })
                .then((res) => {
                    this.removeFavoriteDialog = false;
                    this.getFavoriteCorrespondences()
                })
                .catch(err => this.handleError(err))
        },
        handleError(error) 
        {
            this.loading = false
            console.log(error)
        },
        createSelected()
        {
            if (this.selectedTemplateId === 0)
                return;

            if (this.isDocument)
                this.createByDocument()
            else
                this.createTemplate()
        },
        createTemplate()
        {
            this.viewerFrameSrc = ""; 
            this.empty_viewer = true;

         

            if (this.selectedTemplateId === 0)
                return;

            var signatoryList = ''

            var defaultFormData = '{"senderDesignatedPerson": "", "recipientDesignatedPerson": "", "translatedSubject": "", "keywords": "", "otherAttachments": "", '
            defaultFormData = defaultFormData + '"signers": "[' + signatoryList + ']", "templateId": ' + this.selectedTemplate.id + '}'

            var user = JSON.parse(sessionStorage.getItem("user"));
 
            var saveParams = {
                'CategoryId': this.selectedTemplate.categoryId,
                "TemplateId": this.selectedTemplate.id,
                'CreatedByStructureId': user.profile.StructureId,
                'formData': defaultFormData,
                'linkedDocumentId': this.linkedDocumentId            
            };

            const headers = {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer ' + sessionStorage.getItem('jwt_token')
            };

            window.showLoading()
            axios.post(constants.baseApiUrl + 'Document/Save', saveParams, { headers: headers })
                .then((response) => 
                {
                    if (response.status == 200)
                    {
                        var documentId = response.data
                        this.rememberReplySource(documentId)
                        this.$emit('closeSelectTemplatePopup', documentId)
                    }
                    else
                        alert(response.data.message)
                })
                .catch((err) => console.log(err))
                .finally(() => window.hideLoading())
        },
        getShortDescription(description) 
        {
            if (typeof (description) !== 'undefined' && description !== null) 
            {
                if (description.length > 100)
                    return description.substring(0, 100) + '...'
                else
                    return description
            }
        },
        clearAllFilters() 
        {
            this.search = ''
            this.templateType = -1
            this.language = -1
            this.signatureCount = -1
            this.tag = -1
            this.privacy = -1
            this.viewerFrameSrc = ""
            this.getTemplateFiltersAndStatistics()
            this.searchTemplates()
        },
        clear() 
        {
            this.search = ''
            this.searchTemplates()
        },
        getFavoriteCorrespondences()
        {
            this.favoriteCorrespondences = []
            axios.get(constants.baseApiUrl + "Document/GetUserFavorites")
                .then((res)=>{ 
                    res.data.forEach(element => { 
                    this.favoriteCorrespondences.push({ documentId: element.documentId, favoriteName: element.name, id: element.template.id, 
                    name: element.template.name, language: element.template.language, signatureCount: element.template.signatureCount,
                    descriptionAr: element.template.descriptionAr, descriptionEn: element.template.descriptionEn, categoryId: element.template.categoryId});
                });
            })
            .catch(err => console.log(err));
        },
        rememberReplySource(newDocumentId)
        {
            if (this.linkedDocumentId > 0 && newDocumentId)
                sessionStorage.setItem('pendingLinkedDocument_' + newDocumentId, this.linkedDocumentId)
        },
        createByDocument(){
            window.showLoading()
            axios.post(constants.baseApiUrl + 'Document/CreateCopy?documentId=' + this.documentId)
                .then(response => {
                    if (response.data != null) {
                        var newDocumentId = response.data
                        this.viewerFrameSrc = "";
                        this.empty_viewer = true;
                        this.rememberReplySource(newDocumentId)
                        window.openNewCorrespondenceDialog(String(newDocumentId))
                    }
                })
                .catch(error => console.log(error))
                .finally(() => window.hideLoading())
        },
        openRemoveFavoriteDialog()
        { 
            this.removeFavoriteDialog = true;
        },
        openTreeRemoveFavoriteDialog(id)
        {  
           this.selectedFavoriteDocumentId = id;
           this.removeFavoriteDialogFromTree = true; 
        }
    },
}
</script>

<style scoped>
    .template_filter_container { justify-content: space-between; align-items: flex-end; }
    .template_card:hover, .template_card:focus { background-color: #f1f8ff !important; }
    .template_selected { border: 1px solid #205cdf; }
    .template_card:hover .v-chip.purple, .template_card:focus .v-chip.purple { background: #fff !important; color: #5c068c !important; }
    .template_filter { flex: 1; }
    .filterPopup { min-width: 250px !important; }
</style>